<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter1" id="calibre_pb_0">
<span id="Page_ix" title="ix"></span>
<h2 class="c4" id="pgepubid00002">PREFACE.</h2>
</div>
<p class="c10">Among the multifarious absurdities and
chicaneries, which at different <i class="calibre12"><span xml:lang="la">epocha</span></i> of
society have clung to, and engaged the
attention of man, absorbing, as it were,
his more active intelligence, the marvellous
and the ridiculous have alternately and
conjointly had to contend for pre-eminence;
that, whether it were a mountain in
the moon or a bottle conjuror; a live lion
stuffed with straw or a mermaid; a Cocklane
ghost or a living skeleton; a giant or a
pigmy; the delusive bait has invariably been
swallowed with avidity, and credited with all
the solemnity of absolute devotion.</p>
<p class="c11">If we look back towards what are called
the dark ages of the worlds that is, at times
when men were mere <em class="calibre12">yokels</em>, and when the
reins of tyranny, superstition and idolatry,
were controlled by a few knowing ones, we
shall see the human mind at its lowest ebb of
debasement, grovelling either under the lash
<span id="Page_x" title="x"></span>of despotism, or sunk beneath the scale of human
nature by the influence of priestcraft,—a
time, when the feelings of men were galloped
over, rough shod, and the dignity of the
creation trampled under foot with impunity
and exultation, by a state of the most passive
and degenerate servility: how much must
it now excite our wonder and admiration of
that supreme Providence, who, in his merciful
consideration for the frailest of mortals,
by a variety of ways and means best suited
to his omnipotent ends, has dragged us gradually,
and, as it were, reluctantly to ourselves,
from darkness to daylight, by extinguishing
the stench and vapour of the
train oil of ignorance and superstition,
lighting us up with the brilliant gas of reason
and comparative understanding, while,
under less despotic and more tolerant times,
we are permitted the rational exercise of
those faculties which formerly were rivetted
to the floor of tyranny by the most humiliating
oppression!</p>
<p class="c11">The pranks of popes and priests, conjurors
and fire-eaters, have comparatively
fled before the piercings of the intellectual
ray. Witches no longer untie the winds to
<span id="Page_xi" title="xi"></span>capsise church-steeples, and “topple” down
castles,—they no longer dance round the enchanted
cauldron, invoking the “ould one”
to propitiate their cantrip vows:—Beelzebub
himself with his cloven foot is seldom if
ever seen above the “bottom of the bottomless
pit;” ghosts and apparitions are “jammed
hard and fast” in the Red sea; demons of
every cast and colour are eternally spellbound;
legends are consigned to the chimney-corner
of long winter-nights; miracles
to the “<i class="calibre12"><span xml:lang="fr">presto</span></i>, quick, change and begone!” of
the nimble-fingered conjuror; and holy relics
to the rosary of the bigot. Amulets and
charms have lost their influence; saints are
uncanonized, and St. Patrick, St. Dennis,
&amp; Co. are flesh and blood like ourselves;
monks and holy friars no longer revel in
the debauches of the cloister; the hermit returns
unsolicited from the solitude of the desert,
to encounter with his fellow-men; the
pilgrim lays by his staff, leaves the Holy
Land to its legitimate possessors, and the
tomb of St. Thomas-à-Becket, to enjoy, unmolested,
the sombre tranquillity of the grave.
Quacks and mountebanks begin also to caper
within a narrower sphere; to be brief, the
word of command, to use a nautical phrase,
<span id="Page_xii" title="xii"></span>has long been given, “every man to his station,
and the cook to the fore-sheet,”—worldly
occupations have superseded ultramundane
speculations. Astrologers themselves, who
once ruled the physical world, have long ago
been virtually consigned to the grave of the
Partridges; and floods and storms are found
to be phenomena perfectly consistent with the
natural world. We also know that the sun is
stationary, that the moon is not made of green
cheese, and that there are stars yet in the firmament
which the centifold powers of the
telescope of a Herschell will never be able to
explore.</p>
<p class="c11">The Reformation, which originated in
the trammels of vice itself, gave the Devil in
hell and his agents on earth, such a “<em class="calibre12">belly-go-fister</em>,”
that they have never since been
able to come to the scratch, but in such a petty
larceny-like manner, as to set all their demonological
efforts at defiance. This is the first
time “old Nick” was ever completely floored;
though, it would appear, from the recent
number of new churches, built no doubt with
the pious intention of keeping him in abeyance,
that he has latterly been making a
little head-way;—these, however, with the
“Holy alliance,” like stern-chasers on a new
<span id="Page_xiii" title="xiii"></span>construction, should the “ould one” attempt to
board us again in the smoke of superstition,
will, without much injury to the hull of the
church, pitch him back to Pandemonium, there
to exhaust his demonological rage in the sulphuretted
hydrogen of his own hell; while the
lights of revealed religion, emanating from
these soul-saving foundations, like Sir Humphrey
Davy’s safety-lamp, will give us timely
warning of the choke-damp of damnation before
it have time to explode about our ears.</p>
<p class="c11">It behoves us, nevertheless, to pray that
we may merit this protection, and to watch,
for we know not at what hour the <em class="calibre12">cracksman</em>
may pay us an unwelcome visit; for, whatever
pampered hypocrites and mercenary
prayer-mongers may pretend to the contrary,
our worldly goods, although but of a temporary
and perishable nature, are as essential
to our existence and respectability here below,
as our spiritual faith is necessary to our
heavenly and eternal happiness above, however
unequal the comparison.</p>
<p class="c11">Among the creatures of the Devil, no one
has a more decent claim to his clemency, than
the caterwauling canting hypocrite. The hypocrite
is a genus to which a variety of species
belong, the subdivisions of which are too numerous
<span id="Page_xiv" title="xiv"></span>for our present purpose; we shall only
therefore offer a few remarks on one kind
of these vampyres, drawn from daily observation.
If not absolutely gluttons, although
many of them are <i class="calibre12"><span xml:lang="fr">gourmands</span></i> in excess,
hypocrites are invariably fond of their ungodly
guts, for which they are at all times
ready to sacrifice their God, their King, their
country and their friends. They have a
stomach like a horse, and a reservoir like a
brewer’s vat. The hypocrite of circumstances
prays, or pretends to pray, in adversity, and
swears in good earnest, like a trooper, in prosperity,—he
is either a roaring bedlamite or a
whining calf, a peevish idiot, a buffoon, or a disgusting
bacchanal;—in short, he is capable of
such derogatory pranks and extremes, that, as
the occasion serves, he with equal facility rises
from the bended knee of supplication to extend
the hand of venality, aye, and of sensuality
too, to the object of his latent and ungovernable
concupiscence. His bloated chops,
at one time, resemble a passive pair of bagpipes,
while, at another, they are inflated with
all the arrogance of beggarly pride and momentary
superfluity. He is never ashamed
to beg, and only afraid to steal—although
equally adapted for the one as the other.
<span id="Page_xv" title="xv"></span>A consummate, a brawling, and a suspicious
egotist—he will hear no one but
himself, no opinion but his own. In his
own house he is a bear; in the house of
another, a nuisance; and every where a <i class="calibre12"><span xml:lang="la">nil
desideratum</span></i>. Self-eulogy is his most constant
theme; and his loathsome flattery,
either applied to himself or others, is invariably
bespattered with the most <em class="calibre12">impious</em> invocations
of the Deity, to witness his rebellious
professions of patience, submission, abstinence,
and every other exotic virtue, which
he knows only by name. His cant is of the
basest and most servile description; and for
the attainment of some object, however pitiful
or paltry, important or consequential, he is
the same venal wretch all over. Where his
expectations are defeated, and the yearnings
of his bowels unappeased, his sycophancy is
succeeded by slander, impertinence, insult,
and the most unfounded suspicion. The
cringing, wriggling wretch, at length,
having wormed himself through a world of
unpitied degradation, filth, and obscenity, attempts,
at the end of his career, to offer up
to his God, what has been indignantly rejected
by the Devil—he dies as he lived, a
<span id="Page_xvi" title="xvi"></span>pauper, equally to fortune and fame—without
one redeeming qualification to keep
alive even his name, which is never mentioned
unless mingled with that kindred contempt
and insignificance to which it was by
nature and existence so closely allied.</p>
<p class="c11">Popular traditions are always worth recording;
they illustrate traditions and exemplify
manners: they tend to throw off the
thraldom of the intellect of man, and stimulate
him to exertions compatible with the
intentions of his existence. It is with this
view that the materials of which the following
pages are composed, have been collected.
Priestcraft, the foster-mother of superstition,
is now sunk too far below the horizon ever
to set again in our illumined hemisphere.
The history of their former influence may,
nevertheless, enlighten and amuse, as well
as guard the tender ideas from receiving impressions
calculated to stupify the reason and
riper judgment; thus withdrawing the flimsy
veil of error and credulity, by an exposure of
those fallacies too often credited, because
frequently passed over without the aid of investigation
through the more refined medium
of moral and physical research.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?40b3be63